export function removeUndefinedProperties(obj) {
  return JSON.parse(JSON.stringify(obj))
}
